import { motion } from 'framer-motion'
import { Facebook, Instagram, Linkedin, X } from 'lucide-react'

import profileImg from '../../assets/bikash-ranjan-mandal.jpg'

const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/share/1BaQePuqRu/',
  instagram: 'https://www.instagram.com/brmandal03?igsh=MWM3NmJienZwcW1yYw==',
  linkedin: 'https://www.linkedin.com/in/bikash-ranjan-mandal-13398b23?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  x: 'https://x.com/brmandal03?t=nYoL7eIiBcKTFnMsjsLO4w&s=08',
}

const ICONS = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  x: X,
}


export default function FounderProfileSection() {
  return (
    <section className="bg-sectionBg" id="founder-profile">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="lg:col-span-5"
          >
            <div className="rounded-3xl border border-slate-200 bg-white/70 backdrop-blur p-5 sm:p-6">
              <div className="flex flex-col items-center text-center">
                <div className="relative">
                  <img
                    src={profileImg}
                    alt="Bikash Ranjan Mandal"
                    className="h-56 w-56 rounded-full object-cover border-4 border-white shadow-sm"
                    loading="lazy"
                  />
                  <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-36 h-10 rounded-full bg-brand-primary/10 blur-[10px]" />
                </div>

                <div className="mt-4">
                  <div className="text-lg font-extrabold text-slate-900">Bikash Ranjan Mandal</div>
                  <div className="text-sm font-semibold text-brand-primary">Founder / Pharma Professional</div>
                </div>

                <div className="mt-5 w-full">
                  <div className="text-sm font-semibold text-slate-900 mb-3">Social Media</div>

                  <div className="flex flex-wrap items-center justify-center gap-3">
                    {Object.entries(SOCIAL_LINKS).map(([key, href]) => {
                      const Icon = ICONS[key]
                      return (
                        <a
                          key={key}
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={key}
                          className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white/70 text-slate-700 hover:text-brand-primary hover:border-brand-primary transition"
                        >
                          <Icon size={18} />
                        </a>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.05 }}
            className="lg:col-span-7"
          >
            <div className="rounded-3xl border border-slate-200 bg-white/70 backdrop-blur p-6 sm:p-8">
              <div className="text-sm font-semibold text-brand-primary">Profile Information</div>
              <h2 className="mt-3 text-2xl sm:text-3xl font-extrabold text-slate-900">
                Bikash Ranjan Mandal
              </h2>

              <p className="mt-4 text-sm sm:text-[16px] text-slate-700 leading-relaxed">
                Bikash Ranjan Mandal, education M.Sc.( Chemistry ), Diploma in production management, Diploma in Chemical Engineering, C,C++ & Java, has experienced for 35 years in Bulk Drugs API manufacturing company. Has a proven track record in pharma industry
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="rounded-2xl border border-slate-200 bg-white/60 p-4">
                  <div className="text-xs font-bold text-slate-500">Education</div>
                  <div className="mt-1 text-sm font-semibold text-slate-900">
                    M.Sc.(Chemistry) • Diploma in Production Management & Chemical Engineering
                  </div>
                </div>
                <div className="rounded-2xl border border-slate-200 bg-white/60 p-4">
                  <div className="text-xs font-bold text-slate-500">Experience</div>
                  <div className="mt-1 text-sm font-semibold text-slate-900">35 years in Bulk Drugs API manufacturing</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

